import script from "./AlertMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertMessage.vue?vue&type=script&setup=true&lang=ts"

import "./AlertMessage.vue?vue&type=style&index=0&id=74f88a66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f88a66"]])

export default __exports__